/**
 * Minicart Hero Announcement Bar
 * Injects an announcement bar below "Your Cart" title and above the shipping notice
 */

(function() {
  'use strict';

  /**
   * Get customizer settings from the minicart section
   */
  function getCustomizerSettings() {
    try {
      const customizerData = document.getElementById('minicart-customizer-data');
      if (!customizerData) {
        console.log('Minicart customizer data not found');
        return null;
      }
      
      const data = JSON.parse(customizerData.textContent);
      return data.customizer;
    } catch (error) {
      console.error('Error parsing customizer data:', error);
      return null;
    }
  }

  /**
   * Create and inject the hero announcement bar
   */
  function injectHeroAnnouncementBar() {
    const settings = getCustomizerSettings();
    
    if (!settings) {
      console.log('No customizer settings found');
      return;
    }

    // Check if hero announcement is enabled
    if (!settings.enabled_hero_announcement_bar) {
      console.log('Hero announcement bar is disabled');
      return;
    }

    // Check if message exists
    if (!settings.hero_announcement_message || settings.hero_announcement_message.trim() === '') {
      console.log('No hero announcement message set');
      return;
    }

    // Find the minicart container
    const minicart = document.querySelector('#minicart .minicart__wrapper, #minicart');
    if (!minicart) {
      console.log('Minicart wrapper not found');
      return;
    }

    // Check if announcement already exists
    if (document.querySelector('.hero-announcement-bar')) {
      console.log('Hero announcement bar already exists');
      return;
    }

    // Find the insertion point (after header, before shipping notice or items)
    const header = minicart.querySelector('.minicart__section--header, .minicart__header');
    const shippingNotice = minicart.querySelector('.minicart__shipping-notice, .minicart-shipping-notice');
    const itemsSection = minicart.querySelector('.minicart__section--items, .minicart-product');
    
    const insertionPoint = shippingNotice || itemsSection || header?.nextElementSibling;

    if (!insertionPoint) {
      console.log('Could not find insertion point for announcement bar');
      return;
    }

    // Create the announcement bar element
    const announcementBar = document.createElement('div');
    announcementBar.className = 'hero-announcement-bar';
    announcementBar.innerHTML = settings.hero_announcement_message;
    
    // Apply styles
    announcementBar.style.cssText = `
      background-color: ${settings.bg_hero_announcement_message || '#003452'};
      color: ${settings.color_hero_announcement_message || '#ffffff'};
      padding: 12px 20px;
      text-align: center;
      font-size: 14px;
      line-height: 1.4;
      margin: 0;
      width: 100%;
    `;

    // Insert before the shipping notice or items section
    insertionPoint.parentNode.insertBefore(announcementBar, insertionPoint);
    
    console.log('✓ Hero announcement bar injected successfully');
  }

  /**
   * Initialize and watch for minicart updates
   */
  function init() {
    // Function to attempt injection
    const attemptInjection = () => {
      setTimeout(injectHeroAnnouncementBar, 100);
      setTimeout(injectHeroAnnouncementBar, 300);
      setTimeout(injectHeroAnnouncementBar, 600);
    };

    // Watch for minicart opening
    const observeMinicart = () => {
      const minicartContainer = document.querySelector('.minicart__container, #minicart');
      if (!minicartContainer) {
        setTimeout(observeMinicart, 500);
        return;
      }

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const container = mutation.target;
            if (container.classList.contains('minicart__container--open') || 
                container.classList.contains('is-open')) {
              attemptInjection();
            }
          }
        });
      });

      observer.observe(minicartContainer, {
        attributes: true,
        attributeFilter: ['class']
      });

      // Try injection immediately if minicart is already open
      attemptInjection();
    };

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeMinicart);
    } else {
      observeMinicart();
    }

    // Listen for cart update events
    document.addEventListener('cart:updated', attemptInjection);
    document.addEventListener('cart:refresh', attemptInjection);
    document.addEventListener('minicart:opened', attemptInjection);
  }

  // Start the script
  init();

})();